import { type ReactNode } from 'react';

import { Bounded } from '@/components/ui/Bounded';
import { BrandMark } from '@/components/ui/BrandMark';
import { Screen } from '@/components/ui/Screen';

/** Centered, brand-marked screen frame used by {@link JoinScreen}. */
export function Centered({ children }: { children: ReactNode }) {
  return (
    <Screen className="items-center justify-center">
      <Bounded className="items-center gap-4 px-8">
        <BrandMark />
        {children}
      </Bounded>
    </Screen>
  );
}
